import { render, staticRenderFns } from "./tagItem.vue?vue&type=template&id=b9688b12&scoped=true&"
import script from "./tagItem.vue?vue&type=script&lang=js&"
export * from "./tagItem.vue?vue&type=script&lang=js&"
import style0 from "./tagItem.vue?vue&type=style&index=0&id=b9688b12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9688b12",
  null
  
)

export default component.exports